import * as Constants from './Constants';

const initialState = {
  title: 'Device Setup',
  plansJson: '',
  plansAEM: '',
  selectedOption: 'SELF',
  setFlag: true,
  showError: false,
  deviceSetupService: null,
  continueButtonStatus: false,
  setupInvalidError: false,
  deviceSetupError: false,
  setupNtfyMsg: null,
  setupShowError: false,
  updateSetupProcessStep: false,
};

function deviceSetup(state = initialState, action) {
  switch (action.type) {
    case Constants.GET_PLANS_SUCCESS:
      return { ...state, plansJson: action.response };
    case Constants.UPDATE_SELECTED_OPTION:
      return { ...state, selectedOption: action.response.data };
    case 'SET_FLAG':
      return { ...state, setFlag: action.data };
    case Constants.ERR_OCCURED:
      return { ...state, showError: action.errorSetup, deviceSetupService: action.serviceinfo };
    case 'CONTINUE_BUTTON_ENABLE_STATE':
      return { ...state, continueButtonStatus: action.response };
    case Constants.SETUP_INVALIDCASE_ERROR:
      return { ...state, setupInvalidError: action.response };
    case Constants.DEVICE_SETUP_ERROR:
      return { ...state, deviceSetupError: action.response };
    case Constants.CEF_DEVICE_SETUP_ERROR:
      return { ...state, setupShowError: action.errorSetup, setupNtfyMsg: action.errorMessage };
    case 'UPDATED_SETUP_PROCESSSTEP':
      return { ...state, updateSetupProcessStep: action.value };
    default:
      return state;
  }
}
export const saveSelectedOption = (state = {}, action) => {
  switch (action.type) {
    case 'SAVE_SELECTED_SETUP_OPTION': {
      //  alert('REDUCER')
      //  debugger;
      return { ...state, setupOption: action.response };
    }
    default:
      return state;
  }
};

export default deviceSetup;
